var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-footer", style: _vm.cssVars }, [
    _c(
      "div",
      { staticClass: "mobile-footer__cta", on: { click: _vm.handleGoNation } },
      [
        _vm._v("\n    进入国家平台\n    "),
        _c("span", { staticClass: "mobile-footer__arrow" }, [_vm._v("→")]),
      ]
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mobile-footer__info" }, [
      _c("p", { staticClass: "mobile-footer__line" }, [
        _vm._v("主办单位：北京市教育委员会"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mobile-footer__line" }, [
        _vm._v("承办单位：北京市数字教育中心"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mobile-footer__line" }, [
        _vm._v("ICP备案/许可证号：京ICP备05039435号-5"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mobile-footer__line" }, [
        _vm._v("京公网安备 11010202010352号"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }